(function () {
    'use strict';
    angular.module('jotApp')
        .directive('dashboard', dashboard);

    function dashboard() {
        var directive = {
            restrict: 'E',
            scope: {
                name: '@',
                fleet: '=',
                objectType: '=',
                objectUniqueCode: '=',
                warningCategory: '=',
                warningName: '=',
                detail: '=',
                frameHeight:"@",
                fromDate: '=',
                toDate: '=',
                fromDatel: '=',
                toDatel: '='
            },
            template: '<iframe ng-if="vm.parsedURL.length > 0" width="100%" height="{{vm.frameHeight}}" src="{{vm.parsedURL}}" class="dashboard" name="{{vm.name}}" style="border: 0"></iframe>',
            controller: DashboardDirectiveController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    DashboardDirectiveController.$inject = ['$scope', '$element', 'Dashboard', 'Principal', 'DASHBOARD_TYPE', 'DASHBOARD_PLACEHOLDER'];

    function DashboardDirectiveController($scope, $element, Dashboard, Principal, DASHBOARD_TYPE, DASHBOARD_PLACEHOLDER) {
        var vm = this;
        var domainId = "";
        var dashboardLevel = "";
        var dashboard = "";
        var lastHeight = 996;
        var notMatchHit = 0;

        vm.parsedURL = "";
        vm.lastHeight = 996 + 'px';

        Principal.identity().then(function (account) {
            domainId = account.context.id;
            dashboardLevel = account.userProfile.warningLevel;
        });

        Dashboard.frame({frameReference: vm.name}).$promise.then(function (data) {
            dashboard = data;
            vm.parseURL(data.url);
        });


        vm.parseURL = function(url) {
            if(url && vm.name) {
                if (dashboard.dashboardType === DASHBOARD_TYPE.KIBANA) {
                    url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.domain), DASHBOARD_PLACEHOLDER.KIBANA.domain + ':' + domainId);
                    url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.level), DASHBOARD_PLACEHOLDER.KIBANA.level + ':>=' + dashboardLevel);
                    if (vm.fleet)
                        if (angular.isArray(vm.fleet)) {
                            var fleetIds = '( ' + vm.fleet.map(function (fleet) {
                                return DASHBOARD_PLACEHOLDER.KIBANA.fleet + ':' + fleet.id;
                            }
                            ).join(" OR ") + ' )';
                            fleetIds = fleetIds.replace("fleetId:-1 OR ", "");
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.fleet), fleetIds);
                        } else {
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.fleet), DASHBOARD_PLACEHOLDER.KIBANA.fleet + ':' + (vm.fleet.id == -1 ? '*' : vm.fleet.id));
                        }
                    if (vm.objectType)
                        if (angular.isArray(vm.objectType)) {
                            var objectTypeIds = '( ' + vm.objectType.map(function (objectType) {
                                return DASHBOARD_PLACEHOLDER.KIBANA.objectType + ':' + objectType.id;
                            }
                            ).join(" OR ") + ' )';
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.objectType), objectTypeIds);
                        } else {
                            url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.objectType), DASHBOARD_PLACEHOLDER.KIBANA.objectType + ':' + (vm.objectType.id == -1 ? '*' : vm.objectType.objectTypeName));
                        }
                    if (vm.objectUniqueCode) {
                        url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.objectUniqueCode), DASHBOARD_PLACEHOLDER.KIBANA.objectUniqueCode + ':' + vm.objectUniqueCode);
                    }
                    if (vm.detail) {
                        url = url.replace(wrap(DASHBOARD_PLACEHOLDER.KIBANA.detail), "\"" + vm.detail + "\"");
                    }
                }
                else if (dashboard.dashboardType === DASHBOARD_TYPE.GRAFANA) {

                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.domainId, domainId);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.fleetId, vm.fleet);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.objectType, vm.objectType);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.objectUniqueCode, vm.objectUniqueCode);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.warningCategory, vm.warningCategory);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.warningName, vm.warningName);
                    url = replaceIfDefined(url, DASHBOARD_PLACEHOLDER.GRAFANA.level, dashboardLevel);

                    if (vm.fromDate && vm.toDate) {
                        url = buildGrafanaTimeString(url, vm.fromDate, vm.toDate);
                    } else if (vm.fromDatel && vm.toDatel) {
                        url = buildGrafanaTimeString(url, vm.fromDatel, vm.toDatel);
                    }
                }

                vm.parsedURL = url;
            }
        };

        function replaceIfDefined(url, placeholder, value) {
            const finalValue = (value !== undefined && value !== null && value !== '') ? value : 'All';
            return url.replace(wrap(placeholder), finalValue);
        }

        function wrap(placeholder) {
            return '${{' + placeholder + '}}';
        }

        $scope.$watchGroup(['vm.fleet', 'vm.objectType', 'vm.fromDate', 'vm.toDate', 'vm.fromDatel', 'vm.toDatel'], function (newValues, oldValues) {
            if (oldValues[0] === undefined || oldValues[1] === undefined || (newValues[0] !== undefined && newValues[0].id !== oldValues[0].id) || (newValues[1] !== undefined && newValues[1].id !== oldValues[1].id)
                || (newValues[4] !== undefined && newValues[4] !== oldValues[4]) || (newValues[5] !== undefined && newValues[5] !== oldValues[5])) {
                vm.parseURL(dashboard.url);
            }
        });

        function getTimestamp(date) {
            return date/1;
        }

        function buildGrafanaTimeString(url, fromDate, toDate) {
            if(angular.isDate(fromDate))
                fromDate = getTimestamp(fromDate);

            if(angular.isDate(toDate))
                toDate = getTimestamp(toDate);

            return url + '&from=' + fromDate + '&to=' + toDate;
        }
    }
})();
